// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader_container__Hu79H","actions":"ModalHeader_actions__CwlxQ"};